import { render, staticRenderFns } from "./RoomMirroringPalette.vue?vue&type=template&id=19e30373&scoped=true&"
import script from "./RoomMirroringPalette.vue?vue&type=script&lang=js&"
export * from "./RoomMirroringPalette.vue?vue&type=script&lang=js&"
import style0 from "./RoomMirroringPalette.vue?vue&type=style&index=0&id=19e30373&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e30373",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e30373')) {
      api.createRecord('19e30373', component.options)
    } else {
      api.reload('19e30373', component.options)
    }
    module.hot.accept("./RoomMirroringPalette.vue?vue&type=template&id=19e30373&scoped=true&", function () {
      api.rerender('19e30373', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Mirroring/RoomMirroringPalette.vue"
export default component.exports